const FACT_READERS = Object.freeze({
    'document.scope': context => context.document.scope,
    'document.type': context => context.document.type,
    'document.relevance': context => context.document.relevance,
    'document.hasLegislations': context => context.document.hasLegislations,
    'document.hasScipInformation': context => context.document.hasScipInformation,
    'document.hasSubstances': context => context.document.hasSubstances,
    'document.hasProducts': context => context.document.hasProducts,
    'review.itemStatus': context => context.review.itemStatus,
    'review.productLookupAvailable': context => context.review.productLookupAvailable,
})

const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key)

const evaluateFactCondition = (condition, context) => {
    const readFact = FACT_READERS[condition.fact]
    if (!readFact || ['all', 'any', 'not'].some(operator => hasOwn(condition, operator))) {
        return null
    }

    const hasEquals = hasOwn(condition, 'equals')
    const hasIn = hasOwn(condition, 'in')
    if (Number(hasEquals) + Number(hasIn) !== 1) {
        return null
    }

    const value = readFact(context)
    if (hasEquals) {
        return value === condition.equals
    }

    return Array.isArray(condition.in) && condition.in.length > 0
        ? condition.in.includes(value)
        : null
}

const evaluateConditionNode = (condition, context) => {
    if (!condition || typeof condition !== 'object' || Array.isArray(condition)) {
        return null
    }

    if (hasOwn(condition, 'fact')) {
        if (typeof condition.fact !== 'string') {
            return null
        }

        return evaluateFactCondition(condition, context)
    }

    if (hasOwn(condition, 'equals') || hasOwn(condition, 'in')) {
        return null
    }

    const operators = ['all', 'any', 'not'].filter(operator => hasOwn(condition, operator))
    if (operators.length !== 1) {
        return null
    }

    const operator = operators[0]
    if (operator === 'not') {
        const result = evaluateConditionNode(condition.not, context)

        return result === null ? null : !result
    }

    const children = condition[operator]
    if (!Array.isArray(children) || children.length === 0) {
        return null
    }

    const results = children.map(child => evaluateConditionNode(child, context))
    if (results.includes(null)) {
        return null
    }

    return operator === 'all'
        ? results.every(Boolean)
        : results.some(Boolean)
}

const evaluateDocumentComplianceSectionCondition = (condition, context) => (
    evaluateConditionNode(condition, context) === true
)

export { evaluateDocumentComplianceSectionCondition }
